<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-06-29 16:27:26
 * @LastEditTime: 2022-03-16 11:59:24
 * @LastEditors: chenguobiao
-->
<template>
  <div class="header flex flex-row justify-between items-center">
    <!-- logo  -->
    <home-logo @handleBackHome="handleBackHome"/>
    <el-tag type="warning" v-if="env">{{env}}</el-tag>
    <div class="count-down--give-up">
      <!-- 考试倒计时 -->
      <grading-count-down v-if="showCountDownFlag"></grading-count-down>
      <!-- 放弃考试 -->
      <give-up v-if="showGiveUpFlag"/>
    </div>
    <!-- 用户信息 -->
    <personal v-if="showUserFlag"/>
  </div>
</template>

<script>
import store from 'store'
import HomeLogo from '../logo'
import Personal from '../personal'
import giveUp from '../giveUp'
import gradingCountDown from '../grading-count-down'
import { USER_INFO } from '@/config/const'
export default {
  name: 'Header',
  props: {},
  watch: {
    '$route': {
      immediate: true,
      handler(route) {
        this.showCountDownFlag = ['Grading'].includes(route.name)
        this.showGiveUpFlag = ['Grading', 'GradingReplay'].includes(route.name)
        this.showUserFlag = !['Forget', 'Register', 'Collection'].includes(route.name)
      }
    }
  },
  data() {
    return {
      userInfo: {},
      showGiveUpFlag: false,
      showUserFlag: false,
      showCountDownFlag: false,
      env: ''
    }
  },
  components: { HomeLogo, Personal, giveUp, gradingCountDown },
  computed: {},
  async mounted() {
    this.userInfo = store.get(USER_INFO)
    this.getEnv()
  },
  methods: {
    getEnv() {
      const hostMap = {
        '47.98.106.247': '交付版',
        '47.97.157.12': '测试版'
      }
      const host = location.host
      this.env = hostMap[host]
    },
    handleBackHome() {
      if (this.userInfo) {
        // this.$router.replace('/home')
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  height: val(125);
  padding: 0px val(80);
  background: url('../../../assets/images/header/bg.png') center no-repeat;
  background-size: 100%;
  .count-down--give-up {
    display: flex;
    justify-content: flex-end;
    flex: 1;
  }
}
</style>
